import { useSelector } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { ThemeButton } from '@shared/ui/buttons';
import { DialogContent, DialogActions } from '@mui/material';
import { useState, useRef, useEffect } from 'react';
import { subDays, subMonths, subYears } from 'date-fns';
import { FormGroup } from '@shared/ui/forms/display';
import { icons } from '@shared/static/icons';
import { useDialogContext } from '@app/components/dialogs/DialogProvider';
import { InputGroup, DateRangePicker } from 'rsuite';

const customRanges = [
  {
    label: 'Last Month',
    value: [subMonths(new Date(), 1), new Date()],
  },
  {
    label: 'Last 3 Months',
    value: [subMonths(new Date(), 3), new Date()],
  },
  {
    label: 'Last 6 Months',
    value: [subMonths(new Date(), 6), new Date()],
  },
  {
    label: 'Last Year',
    value: [subYears(new Date(), 1), new Date()],
  },
  {
    label: 'Last Week',
    value: [subDays(new Date(), 7), new Date()],
  },
];

export default function ExportDialog({ close, data }) {
  const { user } = useSelector((state) => state.user);
  const [isLoading, setIsLoading] = useState(false);
  const containerRef = useRef(null);
  const [container, setContainer] = useState(null);
  const { setSubtitle } = useDialogContext();

  useEffect(() => {
    setSubtitle(data.name);
  }, [data]);

  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm();

  async function onSubmit(data) {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }

  useEffect(() => {
    setContainer(containerRef.current);
  }, []);

  function hasValue(val) {
    if (!val) return false;
    if (val.length > 0 && (!val[0] || !val[1])) return false;
    return true;
  }

  return (
    <>
      <DialogContent>
        <div className="form">
          <div className="datepicker-container" ref={containerRef}></div>
          <FormGroup>
            <Controller
              control={control}
              name="dateRange"
              render={({ field }) =>
                container && (
                  <InputGroup
                    className={`${hasValue(field.value) ? 'has-value' : ''}`}
                  >
                    {console.log(field.value)}
                    <InputGroup.Addon>{icons.calendar}</InputGroup.Addon>
                    <DateRangePicker
                      defaultOpen={true}
                      open={true}
                      block
                      caretAs={null}
                      container={container}
                      ranges={customRanges}
                      showHeader={false}
                      cleanable={false}
                      placeholder="Select date"
                      value={field.value}
                      onChange={(value) => field.onChange(value)}
                    />
                  </InputGroup>
                )
              }
            />
          </FormGroup>
        </div>
      </DialogContent>
      <DialogActions>
        <ThemeButton
          onClick={handleSubmit(onSubmit)}
          icon="export"
          loading={isLoading}
          minWidth
        >
          Export
        </ThemeButton>
      </DialogActions>
    </>
  );
}
